<template>
  <div class="modal fade modal-location-details" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          Location Details
        </div>
        <div class="modal-body">

          <p class="material-details material-details-location-contact m-b-lg">
            <i class="fa fa-user"></i> {{ location.contact_name ? location.contact_name : '–' }}<br />
            <i class="fa fa-phone"></i> {{ location.contact_phone ? location.contact_phone : '–' }} <br />
            <i class="fa fa-phone"></i> {{ location.contact_second_phone ? location.contact_second_phone : '–' }} <br />
          </p>

          <div class="row row-clear-sm-6">
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Property / Depot Name</strong><br />
                {{ location.name }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details">
                <strong>UHF Channel</strong><br />
                {{ location.uhf_channel }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Address</strong><br />
                {{ location.address }}
              </p>
            </div>
            <div class="col-sm-6">
              <p class="material-details">
                <strong>Hours of Loading</strong><br />
                {{ location.hours_of_loading }}
              </p>
            </div>
          </div>

          <div class="row row-clear-sm-6 row-details">
            <div class="col-xs-6">
              <p class="material-details">
                <strong>Longitude</strong><br />
                {{ location.longitude }}
              </p>
            </div>
            <div class="col-xs-6">
              <p class="material-details">
                <strong>Latitude</strong><br />
                {{ location.latitude  }}
              </p>
            </div>
          </div>

          <div class="map-container">
            <gmap-map
              ref="map"
              v-if="location.latitude && location.longitude"
              :center="{ lat: location.latitude, lng: location.longitude }"
              style="width: 100%; height:300px"
              :zoom="8"
              :options="{ streetViewControl: false, mapTypeControl: false, animatedZoom: false }">
              <gmap-marker
                :position="{ lat: location.latitude, lng: location.longitude }">
              </gmap-marker>
            </gmap-map>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6 footer-left">
              <a :href="googleMapsLink" target="_blank" class="btn btn-sm btn-primary"><i class="fa fa-google"></i> Open In Maps</a>
            </div>
            <div class="col-sm-6 footer-right">
              <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>

              <button
                v-if="jobIsEditable"
                data-toggle="drawer"
                data-target="#drawer-location-add"
                type="button"
                @click="handleEditLocation"
                class="btn btn-sm btn-info">
                Edit Details
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { jobHelpers } from 'mixins/jobs'
  import $ from 'jquery'

  export default {
    props: ['edit'],

    mixins: [jobHelpers],

    mounted () {
      $('.modal-location-details').on('shown.bs.modal', this.resetSelectedMapZoom)
    },

    computed: {
      ...mapGetters('location', { location: 'locationDecorated' }),

      googleMapsLink () {
        return `https://maps.google.com/maps?q=${this.location.latitude},${this.location.longitude}`
      }
    },

    methods: {
      /**
       * Reset the selected map zoom once modal has loaded.
       *
       * @return void
       */
      resetSelectedMapZoom () {
        this.$nextTick(() => {
          if (this.$refs.map) {
            this.$refs.map.resizePreserveCenter()
          }
        })
      },

      handleEditLocation () {
        this.edit(this.location.decorated)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LocationDetailModal.vue?3306eefb